<!--
    Styles
-->

<style>


    #dashboard .l-nav {
        z-index: 2;
    }
    #dashboard .view {
        position: relative;
        z-index: 1;
    }
    #dashboard .view .map {
        height: 100%;
    }



</style>



<!--
    Template
-->

<template>
    <section id="dashboard" class="u-col">

        <layout-nav />

        <div class="u-row u-stretch u-flex">

            <div class="view u-flex">
                <ui-map class="map" :view="query" :options="mapOptions" :heat-points="heatPoints" @idle="mapped" @zoom="deselect" @click="deselect" ref="map">
                    <marker-station
                        v-for="station in stations"
                        v-coords="station"
                        :station="station"
                        :key="station.id"
                        @click.native="zoomTo(station)"
                    />
                    <marker-building
                        v-for="building in buildings"
                        v-coords="building"
                        v-show="!selected || selected.id !== building.id"
                        :building="building"
                        :key="building.id"
                        @click.native="select(building)"
                    />
                    <marker-details
                        ref="details"
                        v-if="selected"
                        v-coords="selected"
                        :id="selected.id"
                        :max-height="selectedHeight"
                    />
                </ui-map>
                <layout-colors />
                <layout-zoom />
                <ui-loader v-show="pending('refresh') || pending('heatmap') || request" />
            </div>

            <layout-aside />

        </div>
    </section>
</template>



<!--
    Scripts
-->

<script>


    // imports

    import {mapGetters, mapMutations, mapActions} from 'vuex'
    import {validateParams} from '@/common/helpers/params'
    import config from '@/common/configs/map'
    import maps from '@/common/modules/maps'
    import coords from '@/common/directives/coords'
    import uiLoader from '@/components/shared/ui/loader.vue'
    import uiMap from '@/components/shared/ui/map.vue'
    import layoutNav from '@/components/shared/layout/nav.vue'
    import layoutAside from './layout/aside.vue'
    import layoutColors from './layout/colors.vue'
    import layoutZoom from './layout/zoom.vue'
    import markerStation from './markers/station.vue'
    import markerBuilding from './markers/building.vue'
    import markerDetails from './markers/details.vue'


    // helpers

    const padding = 20;

    const changedParams = (from, to) => {
        const keys = Object.keys(to).concat(Object.keys(from));
        const uniq = [...new Set(keys)];
        return uniq.filter(key => to[key] !== from[key]);
    };

    let defaults = {
        type: 'sale',
        lat: config.lat,
        lng: config.lng,
        zoom: config.zoom
    };


    // exports

    export default {

        components: {
            layoutNav,
            layoutAside,
            layoutColors,
            layoutZoom,
            uiMap,
            uiLoader,
            markerStation,
            markerBuilding,
            markerDetails
        },

        directives: {
            coords
        },

        data () {
            return {
                request: false,
                bounds: null,
                query: defaults,
                selected: null,
                selectedHeight: 0,
                mapOptions: {
                    zoomControl: false,
                    minZoom: config.minZoom,
                    maxZoom: config.maxZoom
                }
            }
        },

        computed: {

            ...mapGetters('dashboard', [
                'pending',
                'clusters',
                'heatPoints',
                'priceIcon'
            ]),

            stations () {
                return this.clusters.filter(cluster => cluster.type === 'station')
            },

            buildings () {
                if (this.$route.hash) return;
                return this.clusters.filter(cluster => cluster.type === 'building')
            },

            params () {
                return {...this.query, bounds: this.bounds};
            }

        },

        methods: {

            ...mapMutations('search', [
                'setParams'
            ]),

            ...mapActions({
                refresh: 'dashboard/refresh',
                heatmap: 'dashboard/heatmap',
                sort: 'dashboard/sort',
                warn: 'toasts/warn',
            }),

            setQuery (query) {
                this.$router.push({
                    name: this.$route.name,
                    query: {
                        ...this.query,
                        ...query
                    }
                })
            },

            mapped ({lat, lng, zoom, bounds}) {
                this.bounds = bounds;
                this.query = {...this.query, lat, lng, zoom};
                this.setQuery(this.query);
                this.setParams(this.params);
                this.refresh();
            },

            deselect () {
                this.selected = null;
            },

            zoomTo (station) {
                this.setQuery({
                    lat: station.location.coordinates[1],
                    lng: station.location.coordinates[0],
                    zoom: 16
                })
            },

            select (building) {
                // const [lng, lat] = building.location.coordinates;
                // const map = this.$refs.map.map;
                // const $map = this.$refs.map.$el;
                // const coords = map.convert({lng, lat});
                // const target = {x: coords.x, y: coords.y - $map.offsetHeight / 2 + padding};
                // this.setQuery(map.convert(target).toJSON());
                this.selected = building;
            },

            resize () {
                this.selectedHeight = this.$refs.map.$el.offsetHeight - padding * 2;
            }

        },


        watch: {

            '$route.query': {
                immediate: true,
                handler () {
                    const query = validateParams(this.$route.query, defaults);
                    const changed = changedParams(this.query, query);
                    this.query = query;
                    if (!changed.length) return;
                    if (!this.bounds) return; // map not ready (mapped will be called)
                    if (changed.includes('lat') || changed.includes('lng') || changed.includes('zoom')) return; // was or will be handled by mapped()
                    this.setParams(this.params);
                    if (changed.length === 1 && changed[0] === 'sort') return this.sort();
                    if (changed.length === 1 && changed[0] === 'heatmap') return this.heatmap();
                    this.refresh();
                }
            }

        },

        mounted () {
            this.resize();
            window.addEventListener('resize', this.resize);
            if (this.$route.query.lat && this.$route.query.lng) return;
            this.request = maps.places.getCurrentLocation();
            this.request.then(location => {
                this.request = false;
                if (!location) return this.warn('現在地を取得できませんでした。');
                Object.assign(defaults, location);
                this.setQuery(location);
            });

        },

        destroyed () {
            window.removeEventListener('resize', this.resize);
        }

    }


</script>

